import pagesReducer from "./reducers";

export default pagesReducer;